import React from 'react';
import { useTranslation } from 'react-i18next';
const MbmShippingDelivery = (props) => {
    const { faqLink } = props;
    const { t } = useTranslation();
    return (React.createElement("div", { className: "info-box" },
        !props.onPDP && React.createElement("b", null, t('product.deliveryreturn')),
        React.createElement("p", null,
            t('mbm.deliveryreturnmessage'),
            ' ',
            React.createElement("a", { href: faqLink },
                React.createElement("b", null, t('button.findoutmore'))))));
};
export default MbmShippingDelivery;
